import { httpGet, httpPost } from "../httpService/httpService";
import { AddAuthorDictProposalProps, AddAuthorInstitutionDictProposalProps, AddDictRecordProps, AddDocumentDictProposalProps, AddInstitutionDictProposalProps, 
    AddPublicationDictProposalProps, ApproveDictProposalsProps, DeleteDictRecordProps, EditDictRecordProps, GetDictProposalsProps, RejectDictProposalsProps } from "./types/dictionariesServiceProps";

export const addAuthorDictProposal = async (props: AddAuthorDictProposalProps) => {
    
    const formData = new FormData();
    formData.append('NewAuthor', JSON.stringify(props.newAuthor));
    formData.append('SelectedInstitutionsIds', JSON.stringify(props.selectedInstitutionsIds));
    formData.append('NewInstitutions', JSON.stringify(props.newInstitutions));

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/add-author-dict-proposal`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const addInstitutionDictProposal = async (props: AddInstitutionDictProposalProps) => {
    
    const formData = new FormData();
    formData.append('SelectedAuthorId', props.selectedAuthorId ? props.selectedAuthorId.toString() : "");
    formData.append('NewInstitution', JSON.stringify(props.newInstitution));
    formData.append('IsSingleInstitution', props.isSingleInstitution? props.isSingleInstitution.toString() : "false");

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/add-institution-dict-proposal`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const addAuthorInstitutionDictProposal = async (props: AddAuthorInstitutionDictProposalProps) => {
    
    const formData = new FormData();
    formData.append('SelectedAuthorId', props.selectedAuthorId.toString());
    formData.append('SelectedInstitutionId', props.selectedInstitutionId.toString());

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/add-relation-dict-proposal`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const addDocumentDictProposal = async (props: AddDocumentDictProposalProps) => {
    
    const formData = new FormData();
    formData.append('NewDocument', JSON.stringify(props.newDocument));

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/add-document-proposal`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const addPublicationDictProposal = async (props: AddPublicationDictProposalProps) => {
    
    const formData = new FormData();
    formData.append('NewPublication', JSON.stringify(props.newPublication));

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/add-publication-proposal`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const getDictProposals = async (props: GetDictProposalsProps) => {

    return new Promise((resolve, reject) => (
        httpGet(`${props.apiBase}/get-dict-proposals`)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    ));
}

export const approveDictProposals = async (props: ApproveDictProposalsProps) => {

    const formData = new FormData();
    formData.append('DictProposals', JSON.stringify(props.dictProposals));

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/approve-dict-proposals`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const rejectDictProposals = async (props: RejectDictProposalsProps) => {
    
    const formData = new FormData();
    formData.append('DictProposalIds', JSON.stringify(props.dictProposalIds));

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/reject-dict-proposals`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const addDictRecord = async (props: AddDictRecordProps) => {
    
    const formData = new FormData();
    formData.append('DictLayerId', props.dictLayerId.toString());
    formData.append('NewRecord', JSON.stringify(props.newRecord));

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/add-dict-record`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const editDictRecord = async (props: EditDictRecordProps) => {
    
    const formData = new FormData();
    formData.append('DictLayerId', props.dictLayerId.toString());
    formData.append('NewRecord', JSON.stringify(props.newRecord));
    if (props.overwrite) formData.append('Overwrite', JSON.stringify(props.overwrite));

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/edit-dict-record`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const deleteDictRecord = async (props: DeleteDictRecordProps) => {
    
    const formData = new FormData();
    formData.append('DictLayerId', props.dictLayerId.toString());
    formData.append('RecordId', props.recordId.toString());

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/delete-dict-record`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}